import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext } from '../../../context/navigation-context'
import useForm from '../../../hooks/form-hook'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import useFilter from '../../../hooks/filter-hook'

import SearchInput from '../../../components/SearchInput/SearchInput'
import ClientForm from '../../../components/Modals/ClientForm'
import filterItems from '../../../util/filterItems'
import { LangContext } from '../../../context/lang-context'

const Clients = () => {
    const { fetchMssqlApi } = useFetch()
    const { TRL_Pack } = useContext(LangContext)
    const { setHeaderData } = useContext(NavigationContext)
    // const { TRL_Pack } = useContext(LangContext)
    const { searchedText, updateSearchedText } = useFilter()
    const [scriptOutput, setScriptOutput] = useState(null)
    const [deletingClientId, setDeletingClientId] = useState(null)
    const [clientToDelete, setClientToDelete] = useState(null)
    const [deleteError, setDeleteError] = useState(null)
    const [clientDetails, setClientDetails] = useState(null)
    const [us, setUS] = useState([])

    const { form, openForm, closeForm } = useForm()

    // const [clients, setClients] = useState(null)
    const [customers, setCustomers] = useState([])
    // const getClients = () => {
    //   fetchMssqlApi('clients', {}, clients => setClients(clients))
    // }
    const getCustomers = () => {
        fetchMssqlApi('/customers', {}, customers => setCustomers(customers))
    }

    const submitClient = evt => {
        evt.preventDefault()

        const { name, abbreviation, oldName } = evt.target.elements

        let path, method
        if (form !== 'new') {
            path = `console/customer/${form}`
            method = 'PUT'
        } else {
            path = 'console/customer'
            method = 'POST'
        }
        const abbreviationValue = abbreviation.value.trim().toLowerCase();
        const clientNameValue = name.value.trim();
        const ownerMailValues = form === 'new' ? Array.from(evt.target.querySelectorAll('[name="ownermail"]'), item => item.value.trim()) : [];
        if (!/^[a-z]{3}$/.test(abbreviationValue)) return window.alert('Nieprawidłowa nazwa nowej bazy. Nazwa musi mieć dokładnie 3 litery a-z.');
        if (!clientNameValue) return window.alert('Nie podano nazwy klienta.');
        if (clientNameValue.length > 150) return window.alert('Nazwa klienta jest za długa. Maksymalnie 150 znaków.');
        if (!/^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż0-9 ._-]+$/.test(clientNameValue)) return window.alert('Nieprawidłowa nazwa klienta. Dozwolone są litery, polskie znaki, cyfry, spacje, kropka, myślnik i podkreślenie.');
        if (form === 'new') {
            if (!ownerMailValues.length || ownerMailValues.some(mail => !mail)) return window.alert('Podaj adresy e-mail właścicieli.');
            if (ownerMailValues.some(mail => mail.length > 100)) return window.alert('E-mail właściciela może mieć maksymalnie 100 znaków.');
            if (ownerMailValues.some(mail => !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(mail))) return window.alert('Nieprawidłowy e-mail właściciela.');
            if (new Set(ownerMailValues.map(mail => mail.toLowerCase())).size !== ownerMailValues.length) return window.alert('Adresy e-mail właścicieli nie mogą się powtarzać.');
        }

        if (form === 'new' && customers.some(customer => customer.Abbreviation.toLowerCase() === abbreviationValue)) return window.alert('Taka baza już istnieje')
        if (form !== 'new' && abbreviationValue !== oldName.value.toLowerCase()) return window.alert('Nie można zmienić identyfikatora bazy')

        const data = {
            Name: clientNameValue,
            Abbreviation: abbreviationValue,
            ...(form === 'new' ? { OwnerMails: ownerMailValues } : {}),
            NIP: evt.target.elements.NIP.value.trim(),
            NazwaPod: evt.target.elements.NazwaPod.value.trim(),
            KodUS: evt.target.elements.KodUS.value.trim(),
            AdresPod_ulica: evt.target.elements.AdresPod_ulica.value.trim(),
            AdresPod_miejsc: evt.target.elements.AdresPod_miejsc.value.trim(),
            AdresPod_nrDomu: evt.target.elements.AdresPod_nrDomu.value.trim(),
            AdresPod_nrLok: evt.target.elements.AdresPod_nrLok.value.trim(),
            AdresPod_kodPoczt: evt.target.elements.AdresPod_kodPoczt.value.trim(),
            AdresPod_poczta: evt.target.elements.AdresPod_poczta.value.trim(),
            BankAccount: evt.target.elements.BankAccount.value.trim(),
            InvoiceEmail: evt.target.elements.InvoiceEmail.value.trim(),
            RegulaminZgoda: evt.target.elements.RegulaminZgoda.checked ? 1 : 0
        }

        fetchMssqlApi(path, { method, data }, (response) => {
                setScriptOutput(response?.output || response?.message || 'Brak odpowiedzi ze skryptu')
                closeForm()
                getCustomers()
            },
        )
    }

    const deleteClient = customer => {
        if (deletingClientId !== null) return
        setClientToDelete(customer)
        setDeleteError(null)
    }

    const confirmDeleteClient = () => {
        if (!clientToDelete || deletingClientId !== null) return
        const customerId = clientToDelete.CustomerId
        setDeletingClientId(customerId)
        setDeleteError(null)
        fetchMssqlApi(`console/customer/${customerId}`, { method: 'DELETE' }, response => {
            setDeletingClientId(null)
            setClientToDelete(null)
            setScriptOutput(response?.message || 'Dodano usunięcie bazy do kolejki')
            getCustomers()
        }, err => {
            setDeletingClientId(null)
            setDeleteError(err?.response?.data?.message || err?.message || 'Nie udało się usunąć klienta')
        })
    }

    useEffect(() => {
        fetchMssqlApi('us', {}, response => setUS(Array.isArray(response) ? response : response?.data || []))
    }, [])

    useEffect(() => {
        if (!form || form === 'new') {
            setClientDetails(null)
            return
        }
        setClientDetails(null)
        fetchMssqlApi(`console/customer/${form}`, {}, response => {
            setClientDetails(Array.isArray(response) ? response[0] : response)
        }, () => {
            window.alert('Nie udało się pobrać danych klienta')
            closeForm()
        })
    }, [form])

    useEffect(() => {
        setHeaderData({ text: TRL_Pack.navigation.clients })

        // getClients()
        getCustomers()
    }, [])
    const filteredClients =
        customers && customers.filter(({ Name, Abbreviation }) => filterItems(searchedText, Name) || filterItems(searchedText, Abbreviation))

    return (
        <div>
            {customers && (
                <>
                    <div className="d-flex align-items-center justify-content-between mb-2" style={{ gap: 12 }}>
                        <div className="flex-grow-1"><SearchInput onSearch={updateSearchedText} /></div>
                        <button type="button" className="btn btn-primary btn-sm text-nowrap" onClick={openForm('new')}>
                            <i className="fas fa-plus mr-2" />Dodaj
                        </button>
                    </div>
                    {scriptOutput && (
                        <div className="alert alert-secondary my-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong>Wynik operacji</strong>
                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setScriptOutput(null)}>Zamknij</button>
                            </div>
                            <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', maxHeight: 300, overflow: 'auto' }}>
                                {Array.isArray(scriptOutput) ? scriptOutput.join('\n') : scriptOutput}
                            </pre>
                        </div>
                    )}
                    <div className="overflow-auto">
                        <table className="table table-striped border">
                            <thead>
                            <tr>
                                <th>Klient</th>
                                <th className="text-center">Baza danych</th>
                                <th className="text-center">Liczba terminali PAX</th>
                                <th className="text-center">Liczba terminali NAYAX</th>
                                <th className="text-center">Liczba terminali Newland</th>
                                <th className="text-center">Liczba terminali NEXGO</th>
                                <th className="text-center">Liczba powiązanych automatów z terminalami</th>
                                <th className="text-center">Akcje</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredClients.map(customer => (
                                <tr key={customer.CustomerId}>
                                    <td className="align-middle">{customer.Name}</td>
                                    <td className="text-center align-middle">{customer.Abbreviation.toLowerCase()}</td>
                                    <td className="text-center align-middle">{customer.PAXNo}</td>
                                    <td className="text-center align-middle">{customer.NAYAXNo}</td>
                                    <td className="text-center align-middle">{customer.NEWLANDNo}</td>
                                    <td className="text-center align-middle">{customer.NEXGONo}</td>
                                    <td className="text-center align-middle">{customer.MachineNo}</td>
                                    <td className="text-center align-middle text-nowrap">
                                        {/^[a-z]{3}$/i.test(customer.Abbreviation) && (
                                            <>
                                                <button type="button" className="btn btn-link btn-sm p-1 mr-2" onClick={openForm(customer.CustomerId)} title="Edytuj" aria-label={`Edytuj ${customer.Name}`}>
                                                    <i className="fas fa-edit" />
                                                </button>
                                                <button type="button" className="btn btn-link btn-sm p-1 text-danger" onClick={() => deleteClient(customer)} disabled={deletingClientId !== null} title="Usuń" aria-label={`Usuń ${customer.Name}`}>
                                                    <i className={deletingClientId === customer.CustomerId ? 'fas fa-spinner fa-spin' : 'fas fa-trash'} />
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {!filteredClients.length && (
                                <tr><td colSpan={9} className="text-center text-muted py-4">Brak wyników</td></tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                    {form && (form === 'new' || clientDetails) && (
                        <ClientForm
                            clientData={form !== 'new' ? clientDetails : null}
                            handleSubmit={submitClient}
                            handleClose={closeForm}
                            us={us}
                        />
                    )}
                    {clientToDelete && (
                        <div className="modal show d-block" tabIndex="-1" role="dialog" aria-modal="true" aria-labelledby="delete-client-title" style={{ backgroundColor: 'rgba(0,0,0,.5)' }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="delete-client-title">Potwierdź usunięcie klienta</h5>
                                        <button type="button" className="close" onClick={() => setClientToDelete(null)} disabled={deletingClientId !== null} aria-label="Zamknij"><span aria-hidden="true">&times;</span></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>Czy na pewno chcesz usunąć klienta <strong>{clientToDelete.Name}</strong> ({clientToDelete.Abbreviation})?</p>
                                        <p className="text-danger mb-0">Jeśli klient nie ma powiązanych terminali ani automatów, zostanie usunięty z console, a jego baza trafi do kolejki trwałego usunięcia.</p>
                                        {deleteError && <div className="alert alert-danger mt-3 mb-0">{deleteError}</div>}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setClientToDelete(null)} disabled={deletingClientId !== null}>Anuluj</button>
                                        <button type="button" className="btn btn-danger" onClick={confirmDeleteClient} disabled={deletingClientId !== null}>{deletingClientId !== null ? <><i className="fas fa-spinner fa-spin mr-2" />Usuwanie...</> : 'Usuń klienta'}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default Clients